import React, { useState, useRef } from "react";
import { Button } from "antd";
import { useParams, useLocation } from "react-router-dom"; // Import useParams and useLocation
import { createSubcategory, deleteSubCategory, updateSubCategoryImage ,BASE_URL,uploadAdminImage} from "./../services/api"; // Import required API functions
import "./Sub-category_more.css";
import Swal from "sweetalert2"; // Import SweetAlert
import { useNavigate } from "react-router-dom";

const SubCategoryMore = () => {
  const { categoryId } = useParams(); // Get the category ID from the URL
  const { state } = useLocation(); // Access the passed state
  const [subCategoryData, setSubCategoryData] = useState(
    state?.subcategories || []
  );
  const navigate = useNavigate();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [newSubCategory, setNewSubCategory] = useState("");
  const [newSubCategoryImage, setNewSubCategoryImage] = useState("");
  const [loading, setLoading] = useState(false); // To handle loading state
  const fileInputRefs = useRef({}); // Store refs for each category
  const modalFileInputRef = useRef(null); // Ref for modal file input

  const toggleModal = () => {
    if (isModalVisible) {
      // Reset form when closing modal
      setNewSubCategory("");
      setNewSubCategoryImage("");
      if (modalFileInputRef.current) {
        modalFileInputRef.current.value = "";
      }
    }
    setIsModalVisible(!isModalVisible);
  };

  const handleCreate = async () => {
    if (!newSubCategory) {
      alert("Sub-category name is required");
      return;
    }
    else if (!newSubCategoryImage) {
      alert("Sub-category image is required");
      return;
    }


    try {
      setLoading(true); // Set loading state
      const imageUrl = await uploadImage(newSubCategoryImage);
      // await createSubcategory(newSubCategory, categoryId, newSubCategoryImage);

      const newSubCategoryData = {
        id: `${Date.now()}`,
        serialNo: `${subCategoryData.length + 1}`,
        name: newSubCategory,
        imageUrl: imageUrl,
        date: new Date().toLocaleDateString(),
      }; 

      await createSubcategory(newSubCategory, categoryId, imageUrl);

      setSubCategoryData([...subCategoryData, newSubCategoryData]);
      setIsModalVisible(false);
      setNewSubCategory("");
      setNewSubCategoryImage("");
      // Reset file input
      if (modalFileInputRef.current) {
        modalFileInputRef.current.value = "";
      }
      navigate(`/SubCategoryMore/${categoryId}`);

    } catch (error) {
      console.error("Error creating subcategory:", error);
      alert("Failed to create subcategory. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = (id) => {
    try {
      Swal.fire({
        title: "Are you sure?",
        text: "Press on Ok if you want to Delete SubCategory.",
        showCancelButton: true,
        cancelButtonText: "Cancel",
        icon: "question",
        confirmButtonText: "Ok",
      }).then(async (result) => {
        if (result.isConfirmed) {
          await deleteSubCategory(id);
          navigate(`/category`);
        }
      });
    } catch (err) {
      console.error("Delete failed:", err);
    }
  };
  const uploadImage = async (file) => {
    if (file) {
      const formData = new FormData();
      formData.append("image", file);
      try {
        const response = await uploadAdminImage(formData);
        return response.imageUrl;
      } catch (err) {
        console.error("Error uploading image:", err);
        return null;
      }
    }
    return null;
  };

  const handleUpdateCategoryImage = async (id, event) => {
    try {
      const imageUrl = await uploadImage(event);
      if (imageUrl) {
        await updateSubCategoryImage(imageUrl, id);
        navigate(`/category`);
      }
    } catch (error) {
      console.error("Error updating category image:", error);
    }
  };
  return (
    <div className="sub-category-container">
      <div className="sub-category-header">
        <h2>Sub-Categories</h2>
      </div>

      <Button type="primary" className="create-button" onClick={toggleModal}>
        Add New Sub-Category
      </Button>

      {isModalVisible && (
        <div className="modal-overlay">
          <div className="modal-content">
            <button className="modal-close-button" onClick={toggleModal}>
              ×
            </button>
            <h2>Add New Sub-Category</h2>
            <input
              type="text"
              placeholder="Sub-Category Name"
              value={newSubCategory}
              onChange={(e) => setNewSubCategory(e.target.value)}
            />
             <input
              type="file"
              accept="image/*"
              placeholder="Sub-Category Image"
              ref={modalFileInputRef}
              onChange={(e) => setNewSubCategoryImage(e.target.files[0])}
            />
            <Button
              type="primary"
              className="create-button-gradient text-white"
              onClick={handleCreate}
              loading={loading}
            >
              Add
            </Button>
          </div>
        </div>
      )}

      <table className="sub-category-table">
        <thead>
          <tr>
            <th>No.</th>
            <th>Sub-Category</th>
            <th>Image</th>
            <th>Sub-Category ID</th>
            <th>Delete</th>
          </tr>
        </thead>
        <tbody>
          {subCategoryData.map((subCategory, index) => (
            <tr key={subCategory.id}>
              <td>{index + 1}</td>
              <td>{subCategory.name}</td>
              <td>
                {/* <img
                  src={subCategory.imageUrl?.startsWith('http') ? subCategory.imageUrl : `${BASE_URL}${subCategory.imageUrl}` || "placeholder.png"}
                  alt="SubCategory"
                  width="50"
                  height="50"
                  style={{ cursor: "pointer" }}
                  onClick={() => fileInputRef.current.click()}
                />
                <input
                  type="file"
                  accept="image/*"
                  ref={fileInputRef}
                  style={{ display: "none" }}
                  onChange={(event) =>
                    handleImageUpload(subCategory._id, event)
                  }
                /> */}
               <div
                    className="circle-image"
                    style={{
                      backgroundImage: `url(${subCategory.imageUrl?.startsWith('http') ? subCategory.imageUrl : `${BASE_URL}${subCategory.imageUrl}`})`,
                      width: "50px",
                      height: "50px",
                      borderRadius: "50%",
                      backgroundSize: "cover",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      Swal.fire({
                        title: 'Are you sure?',
                        text: 'Do you really want to change the subcategory image?',
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonText: 'Yes, change it!',
                        cancelButtonText: 'No, keep it',
                      }).then((result) => {
                        if (result.isConfirmed) {
                          if (!fileInputRefs.current[subCategory._id]) {
                            fileInputRefs.current[subCategory._id] = React.createRef();
                          }
                          fileInputRefs.current[subCategory._id].current.click();
                         } else {
                          Swal.fire(
                            'Cancelled',
                            'The category image was not changed.',
                            'info'
                          );
                        }
                      })
                      // if (!fileInputRefs.current[subCategory._id]) {
                      //   fileInputRefs.current[subCategory._id] = React.createRef();
                      // }
                      // fileInputRefs.current[subCategory._id].current.click();
                    }}
                  />
                  <input
                    type="file"
                    accept="image/*"
                    ref={
                      !fileInputRefs.current[subCategory._id]
                        ? (fileInputRefs.current[subCategory._id] =
                            React.createRef())
                        : fileInputRefs.current[subCategory._id]
                    }
                    style={{ display: "none" }}
                    onChange={(event) =>
                      handleUpdateCategoryImage(subCategory._id, event)
                    }
                  />
              </td>
              <td>{subCategory._id}</td>
              <td>
                <button
                  className="more-button"
                  onClick={() => handleDelete(subCategory._id)}
                >
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default SubCategoryMore;
